/** 只显示服务端中文名；服务端未给时原样显示 code。 */
export function positionLabel(position: unknown, fallback?: unknown): string {
  const code = typeof position === "string" ? position.trim() : "";
  const serverLabel = typeof fallback === "string" ? fallback.trim() : "";
  return serverLabel || code;
}
